import React, { useState } from 'react';
import axiosInstance from '../../../../utils/axiosInstance';

const Add = ({ onProductPosted }) => {
  const [newProduct, setNewProduct] = useState({
    name: '',
    image: '',
    description: '',
    isspecial: true,
    originalprice: '',
    discountprice: '',

  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewProduct((prevProduct) => ({
      ...prevProduct,
      [name]: value,
    }));
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    setNewProduct((prevProduct) => ({
      ...prevProduct,
      image: file,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const formData = new FormData();
      formData.append('name', newProduct.name);
      formData.append('image', newProduct.image);
      formData.append('description', newProduct.description);
      formData.append('discountprice', newProduct.discountprice);
      formData.append('originalprice', newProduct.originalprice);
      formData.append('isspecial', newProduct.isspecial);

      // Make a POST request to the API endpoint to add a new product
      const response = await axiosInstance.post('/api/products/special', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      // Trigger the callback to notify the parent component (SpecialProducts) that a new product has been posted
      onProductPosted(response.data);

      // Clear the form after successful submission
      setNewProduct({
        name: '',
        image: null,
        description: '',
        price: '',
        originalprice: '',
        discountprice: '',
      });
    } catch (error) {
      console.error('Error posting new product:', error);
    }
  };

  return (
    <div className="container mx-auto mt-8">
      <h2 className="text-2xl font-bold mb-4">Post a New Product</h2>
      <form onSubmit={handleSubmit} className='w-96'>
        
        <div className="mb-4">
          <label htmlFor="name" className="block text-sm font-medium text-gray-600">
            Product Name
          </label>
          <input
            type="text"
            id="name"
            name="name"
            value={newProduct.name}
            onChange={handleInputChange}
            className="mt-1 p-2 w-full border border-gray-300 rounded-md"
            required
          />
          <input
            type="hidden"
            id="isspecial"
            name="isspecial"
            value={newProduct.isspecial}
            onChange={handleInputChange}
            className="mt-1 p-2 w-full border border-gray-300 rounded-md"
            required
          />
        </div>
        <div className="mb-4">
          <label htmlFor="image" className="block text-sm font-medium text-gray-600">
            Image
          </label>
          <input
            type="file"
            id="image"
            name="image"
            onChange={handleImageChange}
            className="mt-1 p-2 w-full border border-gray-300 rounded-md"
            required
          />
        </div>
        <div className="mb-4">
          <label htmlFor="description" className="block text-sm font-medium text-gray-600">
            Description
          </label>
          <textarea
            id="description"
            name="description"
            value={newProduct.description}
            onChange={handleInputChange}
            rows="4"
            className="mt-1 p-2 w-full border border-gray-300 rounded-md"
            required
          />
        </div>
        <div className="mb-4">
          <label htmlFor="price" className="block text-sm font-medium text-gray-600">
            Add Original Price
          </label>
          <input
            type="text"
            id="originalprice"
            name="originalprice"
            value={newProduct.originalprice}
            onChange={handleInputChange}
            className="mt-1 p-2 w-full border border-gray-300 rounded-md"
            required
          />
        </div>
        <div className="mb-4">
          <label htmlFor="price" className="block text-sm font-medium text-gray-600">
            Add original price
          </label>
          <input
            type="text"
            id="discountprice"
            name="discountprice"
            value={newProduct.discountprice}
            onChange={handleInputChange}
            className="mt-1 p-2 w-full border border-gray-300 rounded-md"
            required
          />
        </div>
       
        <button type="submit" className="px-4 py-2 bg-blue-500 text-white rounded-md">
          Post Product
        </button>
      </form>
    </div>
  );
};

export default Add;
